import { contexts } from '@/domains'
import { Collapse } from 'antd'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { useEffect } from 'react'
import Item, { Header } from './Item'
import styles from './list.module.less'

const { BugContext } = contexts
const { Panel } = Collapse

const List = (props) => {
  const { list } = props
  const store = useLocalObservable(() => ({
    activeKey: [] as any
  }))
  useEffect(() => {
    // @ts-ignore
    window.onGlobalEvent('bugFolderAll', () => {
      store.activeKey = []
    })
    return () => {
      // @ts-ignore
      window.offGlobalEvent('bugFolderAll')
    }
  }, [])
  if (!list.length) return <></>
  return (
    <div className='bug-list'>
      <Collapse
        activeKey={store.activeKey}
        onChange={(e) => (store.activeKey = e)}
      >
        {list.map((item, i) => {
          return (
            <Panel
              showArrow={false}
              key={item.id}
              header={<Header item={item} i={i}></Header>}
            >
              <Item item={item} i={i}></Item>
            </Panel>
          )
        })}
      </Collapse>
    </div>
  )
}
export default observer(List)
